// import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import StatusLogsGql from '@/store/graphql/system/queries/StatusLogs.gql';
import StatusLogTypesGql from '@/store/graphql/system/queries/StatusLogTypes.gql';
import CreateStatusLogGql from '@/store/graphql/system/mutations/CreateStatusLog.gql';
import UpdateStatusLogGql from '@/store/graphql/system/mutations/UpdateStatusLog.gql';

export default {
    fetchList: variables => {
        if (variables.cms) variables.cms = parseInt(variables.cms);
        if (variables.skip) variables.skip = parseInt(variables.skip);
        if (variables.take) variables.take = parseInt(variables.take);

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: StatusLogsGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.StatusLogs))
                .catch(err => reject(err));
        })
    },
    fetchTypes: variables => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: StatusLogTypesGql,
                    variables: Object.assign({}, variables, { cms: parseInt(variables.cms) }),
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.StatusLogTypes))
                .catch(err => reject(err));
        })
    },
    create: statusLog => {
        statusLog = _.removeDeepByKey(statusLog, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateStatusLogGql,
                    variables: { statusLog }
                })
                .then(({ data }) => resolve(data.CreateStatusLog))
                .catch(err => reject(err));
        })
    },
    update: statusLog => {
        statusLog = _.removeDeepByKey(statusLog, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateStatusLogGql,
                    variables: { statusLog }
                })
                .then(({ data }) => resolve(data.UpdateStatusLog))
                .catch(err => reject(err));
        })
    },
};
